import { User } from '../../shared/types/User';

/**
 * Filters out archived user accounts (Z and A IDs) and users with null email from the user list
 * @param users - Array of user objects from the API
 * @returns Filtered array containing only active user accounts with valid email
 * 
 * Exclusion criteria:
 * - Z accounts: Email starts with Z### or displayName ends with (Z)
 * - A accounts: Email is null and displayName ends with (A)
 * - Users with null/undefined email
 */
export const filterArchivedUsers = (users: User[]): User[] => {
  return users.filter(user => {
    // Exclude users with null or undefined email
    if (!user.email) {
      return false;
    }
    
    // Z accounts: email starts with Z### or displayName ends with (Z)
    const isZAccount = user.email.toUpperCase().match(/^Z\d+@/) || user.displayName?.endsWith('(Z)');
    
    // A accounts: email is null and displayName ends with (A)
    const isAAccount = user.email === null && user.displayName?.endsWith('(A)');
    
    // Return only active accounts with valid email (exclude Z and A)
    return !isZAccount && !isAAccount;
  });
};
